import React, { useState } from 'react'
import { Button, Form, Radio, Space, Select, Tooltip } from 'antd'
import styled from '@emotion/styled'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { requiredRule, nonZeroRule, nonNegativeRule } from './Rules'
import { TextFieldNumber } from './../Widgets'

const LoyaltyBonusForm = (props: any) => {
  const {
    bonus,
    stores,
    loyaltyCards,
    closeFormDrawer,
    submitDisabled,
    createBonus,
    updateBonus,
    form
  } = props

  const getValidStores = (loyaltyId: string) => {
    if (!loyaltyId) return []
    const card = (loyaltyCards || []).find((card: any) => card.id === loyaltyId)
    if (card?.all_stores_enabled) return stores
    if (card?.store_ids) {
      return (stores || []).filter((store: any) =>
        card.store_ids.includes(store.id)
      )
    }
    return []
  }

  const [storeOptions, setStoreOptions] = useState(
    bonus ? getValidStores(bonus?.loyalty_card?.id) : []
  )

  const handleLoyaltyCardChange = (id: string) => {
    const validStores = getValidStores(id)
    setStoreOptions(validStores)
    form.setFieldsValue({
      store_id: null
    })
  }

  return (
    <>
      <div className='loyalty-bonus-actions'>
        <DiscardButton
          type='primary'
          ghost
          onClick={() => {
            closeFormDrawer()
          }}
        >
          Discard
        </DiscardButton>
        <Button
          type='primary'
          onClick={() => {
            form.submit()
          }}
          disabled={submitDisabled}
        >
          {bonus ? 'Update' : 'Create'} Bonus
        </Button>
      </div>
      <Form
        form={form}
        className='_pt-24 _pl-24 _pr-24'
        layout='vertical'
        onFinish={bonus ? updateBonus : createBonus}
        data-testid='loyalty-bonus-form'
      >
        <Form.Item name='type' label='Bonus type' rules={requiredRule}>
          <Radio.Group data-testid='bonusType'>
            <Space direction='vertical' align='start'>
              <Radio value='account_creation'>Account Creation</Radio>
              <Radio value='first_purchase'>First Purchase</Radio>
            </Space>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          name='loyalty_card_id'
          label='Loyalty Card'
          rules={requiredRule}
        >
          <Select
            className='_mt-10'
            placeholder='Select loyalty card'
            onChange={(id) => {
              handleLoyaltyCardChange(id)
            }}
          >
            {loyaltyCards?.map((card: any) => (
              <Select.Option key={card.id} value={card.id}>
                {card.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name='store_id'
          label={
            <>
              <span>Location</span>
              <Tooltip
                title={
                  'This is the location where points will be awarded from and is for recording purposes only'
                }
              >
                <QuestionCircleOutlined className='_ml-8 _mr-8' />
              </Tooltip>
            </>
          }
          rules={requiredRule}
        >
          <Select className='_mt-10' placeholder='Select locations'>
            {storeOptions?.map((store: any) => (
              <Select.Option key={store.id} value={store.id}>
                {store.name}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
        <Form.Item
          name='stamp_count'
          label='Number of stamps/points'
          rules={[...requiredRule, ...nonZeroRule, ...nonNegativeRule]}
        >
          <TextFieldNumber inputType='number' min={1} step={1} />
        </Form.Item>
      </Form>
    </>
  )
}

const DiscardButton = styled(Button)`
  margin-right: 8px;
`

export default LoyaltyBonusForm
